export default "__VITE_ASSET__ab01b624__"